/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Tag = ({ color = '#92D3F3', height = 30 }) => {
  return (
    <svg
      width="30"
      height={height}
      viewBox="0 0 30 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.71801 8.71949H8.71801V5.71949H5.71801V8.71949ZM17.2725 25.758L3 11.4855V3H11.4855L25.758 17.2725L17.2725 25.758ZM29.0715 16.344L12.7275 0H0V12.7275C6.132 18.8595 14.037 26.766 17.2725 30C22.059 25.2135 25.3935 21.879 30 17.2725L29.0715 16.344Z"
        fill={color}
      />
    </svg>
  )
}

Tag.propTypes = {
  color: string,
  height: number,
}

export default Tag
